// Public client-side analytics IDs.
// Safe to commit — these are emitted in the rendered HTML and visible to anyone
// who views the page source. They are not secrets.
export const META_PIXEL_ID = '401310756040207';
